import { call, put, takeEvery } from 'redux-saga/effects'
import { types } from '../../types'
import { getAllusers,getUsrInfo } from '../apiRequests/getAllUsersRequest'

function* handleGetAllUsers(action) {
  try {

    const response = yield call(getAllusers, action.params,action.status)

    yield put({
      type: types.GET_ALL_USERS_SUCCESS,
      action: response,
    })
  } catch (error) {

    yield put({
      type: types.GET_ALL_USERS_ERROR,
      error: error.response,
    })
  }
}

function* handleGetUsrInfo(action) {
  try {
    const response = yield call(getUsrInfo, action.params)
    yield put({
      type: types.GET_USER_INFO_SUCCESS,
      action: response,
    })
  } catch (error) {

    yield put({
      type: types.GET_USER_INFO_ERROR,
      error: error.response,
    })
  }
}




function* watcherGetAllUsersSaga() {
  yield takeEvery(types.GET_ALL_USERS_REQUEST, handleGetAllUsers)
  yield takeEvery(types.GET_USER_INFO_REQUEST, handleGetUsrInfo)


}

export default watcherGetAllUsersSaga
